// this_week page
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import MyworkDetailsReducer from './reducers/this_week.reducers';
import * as MyworkActions from './actions/this_week.actions';
import MyworkApp from './components/this_week.component';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import ErrorBoundary from './components/error_boundary/error-boundary';
const mapsStateToPropsMeeting = state => ({
  myWorkData: state,
});

const mapsDispatchToPropsMeeting = dispatch => ({
  actions: bindActionCreators(MyworkActions, dispatch),
});

const MyworkAppComp = connect(mapsStateToPropsMeeting, mapsDispatchToPropsMeeting)(MyworkApp);

const initThisWeekAppComp = function (data) {
  const myworkStore = createStore(MyworkDetailsReducer, data);
  ReactDOM.render(
    <ErrorBoundary>
      <Provider store={myworkStore}>
        <Suspense fallback="loading...">
          <I18nextProvider i18n={i18n}>
            <MyworkAppComp />
          </I18nextProvider>
        </Suspense>,
      </Provider>
    </ErrorBoundary>,
    document.getElementById('thisWeekAIs'),
  );
};

window.initThisWeekAppComp = initThisWeekAppComp;
